/**
 * La pantalla de una fase: sus secciones, delante y explicadas.
 *
 * Es lo que sustituye al menú desplegable. Una lista de nombres obliga a recordar qué era
 * «Procedencia»; una pantalla con una línea al lado lo dice. Y como en varias fases la mitad de
 * las secciones todavía no están, aquí eso se lee como lo que es —un libro tiene siete fases y
 * estamos construyéndolas— en vez de como una aplicación con la mitad de los botones rotos.
 *
 * Lo que está listo va primero. No por diseño: porque es lo que el autor puede usar hoy.
 */
import type { Item } from "./Barra";

export default function Fase(
  { titulo, items, quehace, pendiente, alIr }: {
    titulo: string;
    items: Item[];
    quehace: (id: string) => string;
    pendiente: (id: string) => boolean;
    alIr: (id: string) => void;
  },
) {
  const listas = items.filter((i) => !pendiente(i.id));
  const porVenir = items.filter((i) => pendiente(i.id));

  const ficha = (i: Item, lista: boolean) => (
    <section className="carta ficha" key={i.id}>
      <h2><span className="ico">{i.ico}</span>{i.et}
        {!lista && <span className="sub">pronto</span>}
      </h2>
      <p className="vacio">{quehace(i.id)}</p>
      {lista
        ? <button className="btn" onClick={() => alIr(i.id)}>Abrir</button>
        : <button className="btn fantasma" onClick={() => alIr(i.id)}>Ver qué falta</button>}
    </section>
  );

  return (
    <>
      <div className="saludo">
        <h1>{titulo}</h1>
        <p>
          {listas.length
            ? `${listas.length} de ${items.length} ${items.length === 1 ? "sección lista" : "secciones listas"}.`
            : "Todavía no hay nada de esta fase que puedas usar."}
        </p>
      </div>
      <div className="rejilla">
        {listas.map((i) => ficha(i, true))}
        {porVenir.map((i) => ficha(i, false))}
      </div>
    </>
  );
}
